import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function initials(value?: string) {
  if (!value) return "US";
  return value
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}

export function firstName(value?: string) {
  const clean = value?.trim();
  if (!clean) return "Olá";
  return clean.split(/[\s._-]+/)[0];
}

export function decodeLegacyJson<T>(value: unknown): T {
  let current = value;

  for (let attempt = 0; attempt < 2 && typeof current === "string"; attempt += 1) {
    try {
      current = JSON.parse(current);
    } catch {
      break;
    }
  }

  return current as T;
}

export function normalizeKeys<T>(value: unknown): T {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeKeys(item)) as T;
  }
  if (!value || typeof value !== "object") return value as T;

  const aliases: Record<string, string> = {
    PaginaAtual: "paginaAtual",
    TamanhoPagina: "tamanhoPagina",
    TotalDeItens: "totalDeItens",
    Itens: "itens",
    Ticket: "ticket",
    Usuario: "usuario",
    Empresa: "empresa",
    CodigoEmpresa: "codigoEmpresa",
    Ip: "ip",
    Prioridade: "prioridade",
    Assunto: "assunto",
    Contactar: "contactar",
    Problema: "problema",
    Data: "data",
    Resolvido: "resolvido",
    Anexo: "anexo",
    Anexo2: "anexo2",
    Anexo3: "anexo3",
    AnexosNovos: "anexosNovos",
    Status: "status",
    Statusatual: "statusatual",
    Tipo: "tipo",
    Ultimo_complemento: "ultimo_complemento",
    Ultimo_complemento_data: "ultimo_complemento_data",
    Telefone: "telefone",
    Unidade: "unidade",
  };

  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [
      aliases[key] ?? key,
      normalizeKeys(item),
    ]),
  ) as T;
}
